export default {
  subjectSearchResult: (state: any, getters: any) => {
    return state.subjectSearch.map((subject: any) =>
      getters.subjectById(subject.id),
    );
  },
};
